import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from '@services/http/auth.service';
import { UserService } from '@services/http/user.service';
import { ScreenService } from '@services/screen.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CachedDataService } from '@services/data/cached-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'confirm-sms',
  templateUrl: './confirmUser.component.html'
})

export class ConfirmUserComponent implements OnInit {
  confirmForm: FormGroup;
  errorMessage = '';
  @Output() confirmCodeEvent: EventEmitter<any> = new EventEmitter();
  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private cachedDataService: CachedDataService,
    private authService: AuthService,
    private screenService: ScreenService,
    private router: Router
  ) { }

  ngOnInit() {
    this.initForm();
  }
  ConfirmCode() {
    if (this.confirmForm.invalid) {
      const controls = this.confirmForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }
    this.errorMessage = '';
    this.userService.ConfirmCode(this.cachedDataService.getCurrentUser().userName, this.confirmForm.value.code)
      .subscribe(
        response => {
          this.cachedDataService.setToken(response.token);
          this.cachedDataService.setCurrentUser(response.user);
          this.screenService.isShowLoader = true;
          this.router.navigate(['/personal', response.user.id]);
        },
        error => {
          this.confirmCodeEvent.emit();
          if (error.error.errorMessage && error.error.errorMessage.length) {
            this.errorMessage = error.error.errorMessage;
          } else {
            const errors = error.error.modelState;
            for (error in errors) {
              if (errors[error].field && this.confirmForm.controls[errors[error].field.toLowerCase()]) {
                this.confirmForm.controls[errors[error].field.toLowerCase()].setErrors({ 'error': errors[error].errors });
              } else {
                this.errorMessage = 'Ошибка, попробуйте позже.';
              }

            }
          }
        });
  }
  keyUpField() {
    this.errorMessage = '';
  }
  initForm() {
    this.confirmForm = this.formBuilder.group({
      code: ['', [Validators.required]]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/view/auth/confirmUser/confirmUser.component.ts